import React from "react";
import { formatBook } from "../../../utils/formatOdds";

const REMARK_ICON = `${import.meta.env.BASE_URL}assets/img/icons/remark.png`;

/**
 * 1 CARD 20-20 (teen120) bet table in the reference admin's markup — rendered inside the page's `.casino-detail`:
 *   .dtobx-top > .dragon-box (Player) + .tiebox (Tie) + .tiger-box (Dealer) + .pair-box (Pair)
 *   + .casino-remark (only when the feed has a non-empty remark)
 * Styled by the ported reference `.teen1t20` rules in styles/index.css.
 *
 * Markets like the reference: main = sub ordered by sr (0 Player, 1 Dealer, 2 Tie, 3 Pair);
 * each box gets `.suspended` while its market is not OPEN.
 */
export default function BetTableTeen120({ data = [], onBetClick, exposures = {}, remark }) {
  const list = Array.isArray(data) ? data : [];
  const main = [...list].sort((a, b) => Number(a?.sr) - Number(b?.sr));
  const at = (i, name) => main[i] || list.find((s) => s?.nat === name) || { nat: name };

  const isSuspended = (b) => String(b?.gstatus || "").toUpperCase() !== "OPEN";
  const show = (v) => (v !== undefined && v !== null && v !== "" ? v : 0);
  const getExposure = (name) => {
    const v = exposures[name] ?? exposures[name?.toLowerCase?.()];
    return v != null ? Number(v) || 0 : 0;
  };
  // Reference v-casinofancybook: amount > 0 → book-green, otherwise book-red
  const book = (b, label) => {
    const exp = getExposure(b?.nat ?? label);
    return <span className={`d-block ${exp > 0 ? "book-green" : "book-red"}`}>{formatBook(exp)}</span>;
  };
  const click = (b) => {
    if (isSuspended(b)) return;
    if (!b?.b) return;
    onBetClick?.(b.b, b?.nat, b, "back");
  };
  const boxClass = (cls, b) => `${cls}${isSuspended(b) ? " suspended" : ""}`;

  const player = at(0, "Player");
  const dealer = at(1, "Dealer");
  const tie = at(2, "Tie");
  const pair = at(3, "Pair");

  const odds = (b) => (
    <span className="d-block">
      <b>{show(b?.b)}</b>
    </span>
  );

  return (
    <>
      {main[0] ? (
        <div className="dtobx-top">
          <div className={boxClass("dragon-box", player)} onClick={() => click(player)}>
            <div className="flex-book">
              <b>Player</b> {book(player, "Player")}
            </div>{" "}
            <div className="text-center flex-odds">{odds(player)}</div>
          </div>{" "}
          <div className={boxClass("tiebox", tie)} onClick={() => click(tie)}>
            <div>
              <b>Tie</b>
            </div>{" "}
            <div className="text-center flex-odds">
              {odds(tie)} {book(tie, "Tie")}
            </div>
          </div>{" "}
          <div className={boxClass("tiger-box", dealer)} onClick={() => click(dealer)}>
            <div className="flex-book">
              <b>Dealer</b> {book(dealer, "Dealer")}
            </div>{" "}
            <div className="text-center flex-odds">{odds(dealer)}</div>
          </div>{" "}
          <div className={boxClass("pair-box", pair)} onClick={() => click(pair)}>
            <div>
              <b>Pair</b>
            </div>{" "}
            <div className="text-center flex-odds">
              {odds(pair)} {book(pair, "Pair")}
            </div>
          </div>
        </div>
      ) : null}{" "}
      {remark != null && remark !== "" && (
        <div className="casino-remark mt-3">
          <div className="remark-icon">
            <img src={REMARK_ICON} alt="" />
          </div>{" "}
          {React.createElement("marquee", null, remark)}
        </div>
      )}
    </>
  );
}
